// We need to compare to both boolean and string since the tests use process.env which
// converts to a string, and webpack define plugin does the opposite and converts a string
// to a boolean...
export const isServerSide = () =>
  process &&
  process.env &&
  (process.env.SSR === true || process.env.SSR === 'true');
